//import React from 'react';  
//import React, { useState } from 'react';
import { Button, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
  

interface DialogProps {  
  isOpen: boolean;  
  onClose:any;  
}  

// Create styled button component
const StyledButton = styled(Button)({
  '&.bui-button': {
    backgroundColor: '#002677',
    color: '#ffffff',
    border: '0.0625rem solid #002677',
    borderRadius: '62.4375rem',
    fontFamily: '"Optum Sans", Helvetica, Arial, sans-serif',
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: '1.25rem',
    minHeight: '2.5rem',
    minWidth: '6.25rem',
    padding: '0.25rem 1.5rem',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#001f5e',
      borderColor: '#001f5e'
    },
    '&.is-primary': {
      backgroundColor: '#002677',
      color: '#ffffff'
    }
  }
});

const Dialog: React.FC<DialogProps> = ({ isOpen, onClose }) => {  
//const [openModal, setOpenModal] = React.useState(false);

  if (!isOpen) return null;  
  
  return (  
    <div  
      style={{  
        position: 'fixed',  
        top: 0,  
        left: 0,  
        width: '100%',  
        height: '100%',  
        backgroundColor: 'rgba(0, 0, 0, 0.5)',  
        display: 'flex',  
        justifyContent: 'center',  
        alignItems: 'center',  
        zIndex: 1000,  
      }}  
    >  
      <div  
        style={{  
          background: 'white',  
          padding: '20px',  
          borderRadius: '8px',  
          textAlign: 'center',  
        }}  
      >  
        <p>Warning!  This system contains U.S Government information.  By using this information 
            system, you are consenting to system monitoring for law enforcement and other purposes.
        </p>
        <p>Unauthorized or improper use of, or access to, this computer system may subject you to 
            state and federal criminal prosecution and penalties as well as civil penalties. 
        </p>
        <p> At any time, the government may intercept, search, and seize any communication or data transiting or 
            stored on this information system.  
        </p>  
        <StyledButton 
        className="bui-button is-primary"
        onClick={onClose}
        variant="contained"
      >
        Close
      </StyledButton>
      </div>  
    </div>  
  );  
};  
  
export default Dialog;  


